import * as $ from "jquery";

export function activateMenu() {
    const menuToggle = document.querySelector('.toggle-menu');
    const dropdownToggles = document.querySelectorAll('.dropdownmenu-toggle');
    const mainMenu = document.querySelector('#navigation-main');
    const dropdowns = document.querySelectorAll('.dropdown');
    const body = document.querySelector("#main");
    const page = document.querySelector("body");
    const overlay = document.querySelector(".overlay");
    const overlayMobile = document.querySelector(".overlay_mobile");

    menuToggle.addEventListener('click', function () {
        menuToggle.classList.toggle('open');
        mainMenu.classList.toggle('d-none');
        page.classList.toggle('open_menu');
        if(menuToggle.getAttribute('aria-expanded') === 'false') {
            menuToggle.setAttribute('aria-expanded', 'true');
        } else {
            menuToggle.setAttribute('aria-expanded', 'false');
        }
    });

    for (var i = 0; i < dropdownToggles.length; i++) {
        dropdownToggles[i].addEventListener('click', function (ev) {
            ev.stopPropagation();

            let isClosed = this.nextElementSibling.classList.contains('d-none');
            let isChildMenu = this.parentElement.parentElement.classList.contains('dropdown');

            closeMenus();

            if (isClosed) { // reopen the menu
                this.classList.toggle('icon-chevron-up');
                this.classList.toggle('icon-chevron-down');
                this.nextElementSibling.classList.toggle('d-none');
                this.setAttribute('aria-expanded', 'true');
                this.nextElementSibling.removeAttribute('aria-hidden');
                page.classList.add('open_menu');
            }

            if (isChildMenu) { // reopen the parent
                let parentDropdown = this.parentElement.parentElement;
                parentDropdown.classList.remove("d-none");
                parentDropdown.previousElementSibling.classList.toggle("icon-chevron-up");
                parentDropdown.previousElementSibling.classList.toggle("icon-chevron-down");
                parentDropdown.removeAttribute('aria-hidden');
                page.classList.add('open_menu');
            }
            return false;
        });
    }
    
    let wasAbove1200px = window.innerWidth >= 1200;
    let wasBelow1200pxMobile = window.innerWidth < 1200;
    
    window.addEventListener('resize', function () {
        
    // BIG -> SMALL SCREEN
        const isNowBelow1200px = window.innerWidth < 1200;
        
        if (wasAbove1200px && isNowBelow1200px) {
            menuToggle.classList.remove('open');
            mainMenu.classList.add('d-none');
            page.classList.remove('open_menu');
            menuToggle.setAttribute('aria-expanded', 'false');
            closeMenus();
            page.classList.remove('open_menu');
        }
        wasAbove1200px = window.innerWidth >= 1200;
        
        
    // SMALL -> BIG SCREEN
        const isNowAbove1200pxMobile = window.innerWidth >= 1200;
        if (wasBelow1200pxMobile && isNowAbove1200pxMobile) {
            menuToggle.classList.remove('open');
            mainMenu.classList.add('d-none');
            page.classList.remove('open_menu');
            menuToggle.setAttribute('aria-expanded', 'false');
            closeMenus();
            page.classList.remove('open_menu');
        }
        wasBelow1200pxMobile = window.innerWidth < 1200;
        
    });
    
    function closeMenus() {
        for (var j = 0; j < dropdowns.length; j++) {
            dropdowns[j].classList.add("d-none");
            dropdowns[j].setAttribute('aria-hidden', 'true');
            page.classList.add('open_menu');
        }
        for (var j = 0; j < dropdownToggles.length; j++) {
            dropdownToggles[j].classList.remove("icon-chevron-up");
            dropdownToggles[j].classList.add("icon-chevron-down");
            dropdownToggles[j].setAttribute('aria-expanded', 'false');
            if (window.innerWidth >= 1200) {
                page.classList.remove('open_menu');
            }
        }
    }
    
    
    let isOpenMenu = page.classList.contains('open_menu');
    
    overlay.addEventListener('click', function () {
        menuToggle.click();
        closeMenus();
        page.classList.remove('open_menu');
    })
    
    
    // Funktion zum Überprüfen und Setzen/Entfernen der Klasse
    function checkHeaderScrolled() {
        const header = document.querySelector('#header');
        if (!header) return;
        if (window.scrollY >= 50) {
            header.classList.add('is_scrolled');
        } else {
            header.classList.remove('is_scrolled');
        }
    }
    
    // Beim Laden der Seite prüfen
    window.addEventListener('load', checkHeaderScrolled);
    
    // Beim Scrollen prüfen
    window.addEventListener('scroll', checkHeaderScrolled);
    
}



